module.exports = __webpack_public_path__ + "img/1580258.png";